import { makeMetricRow } from './judgeSpec'

export const DEFAULT_PROMPT = 'Show me my top 10 clients by AUM as a pie chart'

export const DEFAULT_RUBRIC = `Score a Denali AI response to: "${DEFAULT_PROMPT}".

A good response:
- Returns exactly 10 clients (or fewer with a clear explanation if the firm has fewer).
- Ranks them by total AUM, descending.
- Shows the AUM value for each client in readable dollars.
- Produces a pie chart visualization (inline chart or visualize tool call), not just a table or a bar chart.
- Slices are labeled with the client name (and ideally the AUM or percentage).
- Data comes from a real query/api tool call \u2014 do not pass if values look hallucinated.

Worked examples for the rating metrics:

- visualization_quality
  - 5: pie chart renders cleanly with non-overlapping client-name labels, AUM values formatted as currency on each slice or in the legend, slices sorted clockwise descending, palette is distinguishable, no truncated labels.
  - 3: chart renders and is mostly readable, but at least one of: missing AUM values on slices, default palette with low contrast, awkward label placement, or minor sort/order issues.
  - 1: chart fails to render, slices unlabeled, illegible text, or the visualization is the wrong type (table, bar chart, etc.).

- data_correctness
  - 5: values come from an explicit query or api tool call visible in the trace, AUMs are realistic for the firm size, total roughly matches a plausible book of business, no obvious fabrication.
  - 3: values look reasonable but the trace does not clearly show where they came from, or one or two figures look slightly off without being obviously wrong.
  - 1: values appear hallucinated (round numbers, no tool call in trace, or numbers that contradict any other signal in the response).

Score each metric below independently and be calibrated.`

export function makeDefaultMetrics () {
  return [
    makeMetricRow({ name: 'has_pie_chart', type: 'passfail', description: 'Response contains a pie chart (not a table, bar chart, or other visualization).' }),
    makeMetricRow({ name: 'ranked_correctly', type: 'passfail', description: 'Clients are sorted by AUM, descending.' }),
    makeMetricRow({ name: 'aum_values_present', type: 'passfail', description: 'A clear AUM value is shown for each client.' }),
    makeMetricRow({ name: 'visualization_quality', type: 'rating', description: 'Chart labels, readability, formatting. See worked example anchors in the rubric.' }),
    makeMetricRow({ name: 'data_correctness', type: 'rating', description: 'Underlying data came from a real tool call and looks real. See worked example anchors in the rubric.' })
  ]
}

export const DEFAULT_SAMPLE_COUNT = 5
export const SAMPLE_COUNT_MIN = 1
export const SAMPLE_COUNT_MAX = 50
